import { ApiClient } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";

export default class OAuthClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	getAuthorizationUrl = async ({ courseId, callbackUrl }: { courseId: number; callbackUrl: string }) => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/oauth/grant`, {
				credentials: "include",
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ courseId, callbackUrl }),
			});
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.authorization.validate(obj)) {
					return obj.authorizationUrl;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	getOAuthAccessToken = async () => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/oauth/token`, {
				credentials: "include",
			});
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.accessToken.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	refreshStoredToken = async () => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/oauth/refresh`, {
				credentials: "include",
			});
			return response.ok;
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
